import { render, staticRenderFns } from "./EventCardsList.vue?vue&type=template&id=816e66d0"
import script from "./EventCardsList.vue?vue&type=script&lang=js"
export * from "./EventCardsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports